
import { BillRateStatus, isAssignmentInProgress, isOnboardingCredReadyStatus } from "../../Shared/AppConstants";
import {
  Controllers,
  CandidateControllerActions,
} from "../../Shared/AppPermissions";
import { AppPermissions } from "../../Shared/Constants/AppPermissions";
import auth from "../../Auth";

export function DefaultActions(props, stateId, stateIntId, isDocExecuted, isRateLockdown) {
  const { dataItem } = props;
  let isEditable = auth.hasPermissionV2(AppPermissions.CONTRACT_NOT_EDITABLE) && isDocExecuted ? false : true;
  var defaultActions = [
    {
      action: "View",
      // controllerName: Controllers.CANDIDATE,
      // methodName: CandidateControllerActions.READBILLRATE,
      permCode: AppPermissions.CAND_SUB_BILL_RATE_VIEW,
      nextState: "",
      icon: "faEye",
      cssStyle: {
        display:
          dataItem.status != BillRateStatus.DRAFT
            ? "block"
            : "none",
      },
    },
    {
      action: "Edit",
      // controllerName: Controllers.CANDIDATE,
      // methodName: CandidateControllerActions.PUTBILLRATE,
      permCode: AppPermissions.CAND_SUB_BILL_RATE_UPDATE,
      nextState: "",
      icon: "faPencilAlt",
      cssStyle: {
        display:
          dataItem.status == BillRateStatus.DRAFT
            ? "block"
            : "none",
      },
    },
    {
      action: "Remove",
      // controllerName: Controllers.CANDIDATE,
      // methodName: CandidateControllerActions.PUTBILLRATE,
      permCode: AppPermissions.CAND_SUB_BILL_RATE_DELETE,
      nextState: "",
      icon: "faTrashAlt",
      cssStyle: {
        display:
          dataItem.status == BillRateStatus.DRAFT
            ? "block"
            : "none",
      },
    },
    {// THIS SECTION IS FOR HR MANAGER IN MAKE IN OFFER For PENDING OFFER STATE
      action: "Edit",
      // controllerName: Controllers.CANDIDATE,
      // methodName: CandidateControllerActions.POSTCANDSUBINTERVIEW,
      permCode: AppPermissions.CAND_SUB_BILL_RATE_UPDATE,
      nextState: "",
      icon: "faPencilAlt",
      cssStyle: {
        display:
              dataItem.status == BillRateStatus.APPROVED && (stateId == "Ready for Offer" || isOnboardingCredReadyStatus(stateIntId)  || (isAssignmentInProgress(stateIntId) && isEditable))
            ? "block"
            : "none",
      },
    },
    {// THIS SECTION IS FOR HR MANAGER IN MAKE IN OFFER For PENDING OFFER STATE
      action: "Remove",
      // controllerName: Controllers.CANDIDATE,
      // methodName: CandidateControllerActions.DELETEBILLRATE,
      permCode: AppPermissions.CAND_SUB_BILL_RATE_DELETE,
      nextState: "",
      icon: "faTrashAlt",
      cssStyle: {
        display:
              dataItem.status == BillRateStatus.APPROVED && (stateId == "Ready for Offer" || (isAssignmentInProgress(stateIntId) && isEditable))
            ? "block"
            : "none",
      },
    },
    {
      action: "Override Bill Rate",
      permCode: AppPermissions.CAND_SUB_BILL_RATE_OVERRIDE,
      nextState: "",
      icon: "faPencilAlt",
      cssStyle: {
        display:
          dataItem.status != BillRateStatus.DRAFT && isRateLockdown
            ? "block"
            : "none",
      },
    },
    {
      action: "View Events",
      permCode: AppPermissions.EVENT_VIEW,
      nextState: "",
      icon: "faEye",
      linkUrl:`/admin/eventslogs/manage/${dataItem.subBillRateId}`,
    }
  ];
  return defaultActions;
}
